<template>
  <div v-if="visible"  class="popup-overlay" @click.self="closePopup">
    <div class="popup">
      <button class="popup__close" @click="closePopup">×</button>

      <h2 class="popup__title">Мудрость #{{ tip?.id }}</h2>

      <div class="popup__content">
        <div class="popup__tip">
          {{ tip?.text }}
        </div>
      </div>

      <button class="popup__action" @click="closePopup">Хорошо</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import tipsData from '@/data/tips.json' // путь к JSON-файлу

const visible = ref(false)
const tip = ref(null)

const STORAGE_KEY = 'daily_tip_date'

function alreadyShownToday() {
  const today = new Date().toISOString().split('T')[0]
  return localStorage.getItem(STORAGE_KEY) === today
}

function setShownToday() {
  const today = new Date().toISOString().split('T')[0]
  localStorage.setItem(STORAGE_KEY, today)
}

function getRandomTip() {
  const index = Math.floor(Math.random() * tipsData.length)
  return tipsData[index]
}

function closePopup() {
  visible.value = false
}

onMounted(() => {
  if (!alreadyShownToday()) {
    tip.value = getRandomTip()
    visible.value = true
    setShownToday()
  }
  tip.value = getRandomTip()
})
</script>

<style lang="scss" scoped>
.popup-overlay {
  padding: 20px;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup {
  width: 320px;
  padding: 20px;
  border-radius: 16px;
  background-image: url("../../images/backgrounds/started.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__close {
    position: absolute;
    top: 10px;
    right: 12px;
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: white;
  }

  &__title {
    margin: 0;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__tip {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 8px 10px;
    border-radius: 10px;
    font-size: 14px;
  }

  &__action {
    margin-top: 8px;
    padding: 10px 16px;
    background-color: rgba(146, 150, 157, 0.16);
    border: none;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #fdd835;
    }
  }
}
</style>
